import BaseModel from "../base/baseModel";

export default class PacienteAlergiaModel extends BaseModel {
    id?: number = null;
    pacienteId?: number = null;
    produtoId?: number = null;
    produtoDescricao?: string = null;
}
